/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2023.
 * Title: MagazzinoModule.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/GESFF_Gestionale_FF_Angular/src/app/Magazzino/MagazzinoModule.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 05/12/23, 14:48;
 * Updated at: 05/12/23, 14:48;
 *
 *
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {SharedModule} from "../shared/Shared.module";
import {NgMultiSelectDropDownModule} from "../../LibrerieCustom/MultiselectDropdown";
import {NgbModalModule, NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import { MagazziniListComponent } from './magazzini-list/magazzini-list.component';
import { MagazzinoComponent } from './magazzino/magazzino.component';
import {FeatherModule} from "angular-feather";
import {StampeModule} from "../Stampe/Stampe.module";
import { MovimentazioniComponent } from './movimentazioni/movimentazioni.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import { MovimentazioneComponent } from './movimentazione/movimentazione.component';

const routes: Routes = [
  {
    path: 'list/:type',
    data: {
      title: "LISTA",
      urls: [{ title: "Lista"}],
    },
    component: MagazziniListComponent,
  },
  {
    path: 'movimentazioni/:type',
    data: {
      title: "LISTA",
      urls: [{ title: "Lista"}],
    },
    component: MovimentazioniComponent,
  },
  {
    path: 'movimentazioni/:type/:type2',
    data: {
      title: "Movimentazioni",
      urls: [{ title: "Movimentazioni"}],
    },
    component: MovimentazioniComponent,
  },
];

@NgModule({
  declarations: [
    MagazziniListComponent,
    MagazzinoComponent,
    MovimentazioniComponent,
    MovimentazioneComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModalModule,
    RouterModule.forChild(routes),
    NgbPaginationModule,
    TranslateModule,
    FeatherModule,
    StampeModule,
    DragDropModule,
  ]
})
export class MagazzinoModule { }
